// src/i18n/es/tagTypes.js
export const tagTypes = {
    name: 'Tipo de ID |||| Tipos de ID',
    title: 'Tipos de ID',
    titles: {
        list: 'Tipos de ID',
        create: 'Crear Tipo de ID',
        edit: 'Editar Tipo de ID',
    },
    fields: {
        id: 'ID',
        typeCode: 'Código de Tipo',
        name: 'Nombre',
        description: 'Descripción',
        icon: 'Icono',
        color: 'Color',
        canEdit: 'Editable',
        canDelete: 'Eliminable',
        isSystemGenerated: 'Generado por Sistema',
        requiresManualInput: 'Entrada Manual',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
        search_placeholder: 'Buscar tipos de ID...',
        system_tooltip: 'Generado por el sistema (no editable)',
        display_name: 'Nombre para Mostrar',
        unique_identifier: 'Identificador único',
        readable_name: 'Nombre legible para el usuario',
        character_count: 'caracteres'
    },
    actions: {
        create: 'Nuevo Tipo de ID',
        edit: 'Editar',
        delete: 'Eliminar',
        cancel: 'Cancelar',
        save: 'Guardar Cambios',
        create_submit: 'Crear Tipo de ID'
    },
    messages: {
        access_denied: 'Acceso Denegado. Solo SuperAdmins pueden gestionar los tipos de ID.',
        no_types: 'No se encontraron tipos de ID',
        loading: 'Cargando tipos...',
        create_success: 'Tipo de ID creado con éxito',
        update_success: 'Tipo de ID actualizado con éxito',
        delete_success: 'Tipo eliminado con éxito',
        delete_confirm: '¿Estás seguro de que quieres eliminar el tipo de ID "%{name}"?',
        delete_warning: 'Esta acción no se puede deshacer.',
        system_type: 'Este es un tipo de sistema y no puede ser modificado',
        create_info: 'Los tipos de ID definen cómo los huéspedes acceden a sus taquillas. Solo los administradores del sistema pueden crear nuevos tipos.',
        edit_warning: 'Cambiar el "Type Code" puede afectar a los IDs existentes que usan este tipo.'
    },
    tooltips: {
        system_generated: 'El sistema puede generar códigos automáticamente',
        manual_only: 'Solo entrada manual',
        requires_manual: 'Requiere entrada manual del usuario',
        automatic: 'Generación automática',
    },
    sections: {
        new_title: 'Nuevo Tipo de ID',
        new_subtitle: 'Complete los datos para crear un nuevo tipo de ID',
        details: 'Detalles del Tipo de ID',
    },
    help: {
        typeCode: 'Selecciona el tipo de identificador',
        name: 'Nombre legible para el usuario',
        description: 'Descripción opcional (máx. 500 caracteres)',
        displayName: 'Nombre legible para el usuario',
        manualInput: 'Si está marcado, requiere que el usuario ingrese el código manualmente'
    },
    validation: {
        code_required: 'El código es obligatorio',
        code_format: 'El código debe ser alfanumérico',
        name_required: 'El nombre es obligatorio',
        typeCode_validation: 'Identificador único (ej. NFC_UID)',
        name_validation: 'Nombre legible para el usuario',
        description_validation: '0/500 caracteres',
        type_code_required: 'El Type Code es obligatorio',
        type_code_min_length: 'Debe tener al menos 3 caracteres',
        type_code_no_spaces: 'No puede contener espacios',
        type_code_format: 'Solo mayúsculas, números y guiones bajos',
        name_min_length: 'Debe tener al menos 3 caracteres',
        description_max_length: 'La descripción no puede exceder los 500 caracteres'
    },
    dialogs: {
        delete_title: 'Eliminar Tipo de ID',
        delete_message: '¿Estás seguro de que quieres eliminar el tipo de ID "%{name}"?',
        delete_warning: 'Esta acción no se puede deshacer.'
    },
    examples: {
        title: 'Ejemplos comunes:',
        nfc_uid: 'Tarjeta NFC de Hotel',
        qr_code: 'Código QR (auto-generado)',
        numeric_code: 'Código numérico de 8 dígitos',
        barcode_128: 'Formato de código de barras estándar'
    },
    notifications: {
        type_updated_success: 'Tipo de ID actualizado con éxito',
    }
};